import React from 'react';

function ContactPage() {
  return (
    <>
      <h2>Let's Get in Touch!</h2>
      <p>Feel free to reach out and tell me a little bit about you!</p>
      <p>
        Click{' '}
        <a href="mailto:bryanni@oregonstate.edu?subject=Contact&body=Enter your message here.">
          HERE
        </a>
        {' '}to contact me using your preferred email application!
      </p>
    </>
  );
}

export default ContactPage;